/* eslint-disable @typescript-eslint/no-empty-object-type */
import { createTheme } from '@mui/material/styles';

import { components } from './components.ts';
import { themeColors } from './themeColors.ts';
import { type KnowMeTypography, type KnowMeTypographyOverrides, typography } from './typography.ts';
import { variables } from './variables.ts';

declare module '@mui/material/styles' {
  interface Theme {
    colors: typeof themeColors;
    variables: typeof variables;
  }

  // allow configuration using `createTheme`
  interface ThemeOptions {
    colors: Partial<typeof themeColors>;
    variables: Partial<typeof variables>;
  }
}

declare module '@mui/material/styles' {
  interface TypographyVariants extends KnowMeTypography {}

  // allow configuration using `createTheme`
  interface TypographyVariantsOptions extends Partial<KnowMeTypography> {}
}

declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides extends KnowMeTypographyOverrides {}
}

export const MAX_WIDTH = '1600px';

export const knowMeTheme = createTheme({
  colors: themeColors,
  components,
  palette: {
    primary: {
      contrastText: themeColors.white,
      dark: themeColors.darkBlue,
      light: themeColors.oceanBlue || themeColors.blue,
      main: themeColors.blue,
    },
    warning: {
      main: themeColors.red,
    },
  },
  typography,
  variables,
});
